export default ($element) => {
    // todo really slow on long pages because scroll listener
    let $scrollTop = $('.scroll-top');

    if ($element.find('.scroll-top').length > 0) {
        $scrollTop = $element.find('.scroll-top');
    }

    $element.scroll(event => {
        let $item = $(event.currentTarget);

        if ($item.scrollTop() <= 200) {
            $scrollTop.removeClass('show-me');
            return;
        }

        $scrollTop.addClass('show-me');
    });

    $scrollTop.on('click', event => {
        let $item = $(event.currentTarget);
        let $target = $($item.attr('href'));

        if ($target.length) {
            event.preventDefault();
            let $scrollTo = $element;
            let scrollTo = ($item.scrollTop() - $item.offset().top + $target.offset().top);

            if ($.isWindow($element[0])) {
                $scrollTo = $('html, body');
            }

            $scrollTo.animate({
                scrollTop: scrollTo
            }, 750);
        }

        return false;
    });
};